<div class="wrap">
    <div class="c-6-set c-7-set-l c-12-set-m c-12-set-s m-b-0">
        <!-- title -->
        <h1 class="h3 col-1"
            *iCms="'title' of component"></h1>

        <!-- content -->
        <div class="p1 col-12 m-t-2"
             *iCms="'text' of component; content 'html'"></div>
    </div>
</div>